import { render, staticRenderFns } from "./StatementTaskModal.vue?vue&type=template&id=392a918c&"
import script from "./StatementTaskModal.vue?vue&type=script&lang=js&"
export * from "./StatementTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports